import React, { useState, useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { fetchProfileContent, baseURL } from '../../utils/usermanagement';
import Flatpickr from "react-flatpickr";

const Section = (props) => {
    const [isComponentMounted, setIsComponentMounted] = useState(true);

    useEffect(() => {
        return () => {
            setIsComponentMounted(false);
        };
    }, []);

    // 新增问候语函数
    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return "Good Morning";
        if (hour < 18) return "Good Afternoon";
        return "Good Evening";
    };
    
    const user = JSON.parse(sessionStorage.getItem("user")); 

    const handleDateChange = (dates) => {
        if (isComponentMounted && props.onDateChange) {
            props.onDateChange(dates);
        }
    };

    const handleRightClick = () => {
        if (isComponentMounted && props.rightClickBtn) {
            props.rightClickBtn();
        }
    };
    
    return (
        <React.Fragment>
            <Row className="mb-3 pb-1">
                <Col xs={12}>
                    <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                        <div className="flex-grow-1">
                            <h4 className="fs-16 mb-1">{getGreeting()}, {user?.name || 'User'}!</h4>
                            <p className="text-muted mb-0">Here's what's happening with your store today.</p>
                        </div>
                        <div className="mt-3 mt-lg-0">
                            <form action="#">
                                <Row className="g-3 mb-0 align-items-center">
                                    <div className="col-sm-auto">
                                        <div className="input-group">
                                            <Flatpickr
                                                className="form-control border dash-filter-picker"
                                                options={{
                                                    mode: "range",
                                                    dateFormat: "d M, Y",
                                                    defaultDate: [
                                                        new Date().getFullYear() + "-01-01",
                                                        new Date().getFullYear() + "-12-31"
                                                    ]
                                                }}
                                                onChange={handleDateChange}
                                            />
                                            <div className="input-group-text bg-primary border-primary text-white">
                                                <i className="ri-calendar-2-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto">
                                        <button 
                                            type="button" 
                                            className="btn btn-soft-secondary btn-icon waves-effect waves-light layout-rightside-btn" 
                                            onClick={handleRightClick}
                                        >
                                            <i className="ri-pulse-line"></i>
                                        </button>
                                    </div>
                                </Row>
                            </form>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default Section;